<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import { truncate } from '@/scripts/utils';
import { mobile } from '@/scripts/computed';

export default {
  name: 'GameStep',
  components: {
    // CustomComponent,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default: '',
    },
    step: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
    mobile,
    description() {
      const { description, position } = this.step;
      const result = `<p>${position}. ` + description.slice(3);

      /* TODO: del */
      /* return description && !this.mode && !this.mobile
        ? this.truncate(result, 100)
        : result; */

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    truncate,
  },
};
</script>

<template>
  <div :class="{ step: true, [mode]: mode }">
    <div class="step__img">
      <img :src="step.image.url" />
      <div class="step__count">{{ step.position }}</div>
      <div class="step__hover">
        <img :src="require('@/assets/svg/zoom-in.svg')" />
      </div>
    </div>
    <div v-html="description" class="step__text"></div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.step {
  padding-left: 20px;

  &__img {
    position: relative;
    width: 250px;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
      border-radius: 12px;
    }

    &:hover {
      .step__hover {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &__hover {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(29, 36, 41, 0.7);
    border-radius: 12px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s;

    img {
      width: 24px;
      height: 24px;
      display: flex;
    }
  }

  &__count {
    position: absolute;
    top: -15px;
    left: -20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #ffce00;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    font-family: Sen-Bold;
    font-size: 14px;
    line-height: 17px;
    color: #0e0e0e;
    z-index: 1;
  }

  &__text {
    margin-top: 32px;
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.71;
    color: #ffffff;
  }

  &.slider {
    padding-left: 15px;
    max-width: 771px;

    .step__img {
      width: 100%;
      height: 423px;
      margin: 0 auto;
      cursor: initial;
    }

    .step__hover {
      display: none;
    }

    .step__count {
      top: -25px;
      left: -25px;
      width: 48px;
      height: 48px;
      font-size: 24px;
      line-height: 29px;
    }

    .step__img {
      img {
        border-radius: 12px;
      }
    }

    .step__text {
      margin-top: 30px;
      border-top: solid 2px rgba(255, 206, 0, 0.5);
      font-family: Poppins-Regular;
      font-size: 16px;
      line-height: 24px;
      padding-top: 14.5px;
    }
  }
}

::v-deep p {
  margin: 0;
}

@media (max-width: $mobile) {
  .step {
    padding-left: 15px;

    &__img {
      margin: 0 auto;
      width: auto;
      height: auto;
      cursor: initial;
    }

    &__text {
      margin-top: 25px;
      font-size: 16px;
      line-height: 1.88;
    }

    &__hover {
      display: none;
    }

    &__count {
      left: -15px;
    }

    &.slider {
      display: none;
    }
  }
}
</style>
